<template>
<div class="chapter">
<div class="inner_page">
<div style="min-width: 500px; margin-right:auto; margin-left:auto;">
<img alt="cover" src="OEBPS/images/9780802190178_Outside_Front_Cover.png" style="height: 100%; max-width:100%;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cvi.vue?9af91d60